module.exports = __webpack_public_path__ + "img/header.76548383.svg";